import {createFileRoute} from '@tanstack/react-router';
import {MdPage} from '../../components/MdPage';
import {getMdComponent} from '../../getMdComponent';

const SectionComponent = () => {
    const Section = Route.useLoaderData();
    if (Section) {
        return <MdPage {...Section} />;
    }
    return null;
};

export const Route = createFileRoute('/_auth/$section/')({
    loader: async ({params: {section}}) => getMdComponent(section, 'index'),
    component: SectionComponent,
});
